module.exports = __webpack_public_path__ + "68d458083ed85320d2819ca3581a47db.jpg";